import { render, staticRenderFns } from "./yearSelect.vue?vue&type=template&id=3058a210&scoped=true"
import script from "./yearSelect.vue?vue&type=script&lang=js"
export * from "./yearSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3058a210",
  null
  
)

export default component.exports